$bog_fragile_demo_collide_named1 $bog_fragile_demo_collide_base1
	sub /
		^
		<= Attach $mol_view
			sub / <= attach_icon \📎
